// Bound public card copy at a word boundary; never manufacture profile text.
export const cardExcerpt = (value, maxLength = 150) => {
  if (typeof value !== 'string') return '-';
  const text = value.replace(/\s+/gu, ' ').trim();
  if (!text) return '-';
  if (text.length <= maxLength) return text;
  const words = text.split(' ');
  let excerpt = '';
  for (const word of words) {
    const next = excerpt ? `${excerpt} ${word}` : word;
    if (excerpt && next.length > maxLength) break;
    excerpt = next;
  }
  return excerpt === text ? text : `${excerpt}…`;
};
